import { render, staticRenderFns } from "./CoinbaseMerged.vue?vue&type=template&id=f25d21d0&scoped=true&"
import script from "./CoinbaseMerged.vue?vue&type=script&lang=js&"
export * from "./CoinbaseMerged.vue?vue&type=script&lang=js&"
import style0 from "./CoinbaseMerged.vue?vue&type=style&index=0&id=f25d21d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25d21d0",
  null
  
)

export default component.exports